export const isValidWebInteractive = content => {
  if (!content) {
    return true;
  }
  const isEmbedded = content.containerType === 'EMBEDDED';
  const isFeedback = content.parentSource === 'FEEDBACK';
  return !content.isSmartCta && !content.isActiveAbTest && !isEmbedded && !isFeedback;
};